export default (state = {}, { type, payload }) => {
    switch (type) {
        case 'HANDLE_INFO_WINDOW_OPEN':
            return {
                ...state,
                infoWindowFunction: payload
            };
        default:
            return state;
    }
};
